import { Info } from "lucide-react";
import type { FunctionComponent } from "react";
import { useState } from "react";
import { AppUserProfile } from "../auth/app-user-profile";
import { HamburgerMenu } from "~/components/buttons/hamburger-menu";
import { AppAboutInfoModal } from "./app-about-info-modal";
import { AppLanguageSelector } from "./app-language-selector";
import { AppThemeSelector } from "./app-theme-selector";
import { AppTitle } from "./app-title";
import { Button } from "~/components/ui";

interface AppHeaderProps {
  isAppSiderCollapsed: boolean;
  toggleAppSiderCollapse: () => void;
}

export const AppHeader: FunctionComponent<AppHeaderProps> = ({ isAppSiderCollapsed, toggleAppSiderCollapse }) => {
  const [isAboutModalOpen, setIsAboutModalOpen] = useState(false);
  const toggleAboutModal = () => setIsAboutModalOpen((s) => !s);

  return (
    <>
      <div className="flex h-full w-full items-center justify-between">
        <HamburgerMenu isActive={!isAppSiderCollapsed} onClick={toggleAppSiderCollapse} />
        <AppTitle />

        <div className="inline-flex items-center gap-2">
          <AppUserProfile onAboutClick={toggleAboutModal} />
          <div className="hidden sm:flex items-center gap-2">
            <AppLanguageSelector />
            <AppThemeSelector />
            <Button
              className="border-2"
              variant="default"
              shape="circle"
              icon={<Info size={16} />}
              onClick={() => toggleAboutModal()}
            />
          </div>
        </div>
      </div>

      <AppAboutInfoModal open={isAboutModalOpen} onClose={toggleAboutModal} />
    </>
  );
};
